// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__19IKj","slider":"switch_slider__kFtuK","round":"switch_round__9Jeas"};